import { render, staticRenderFns } from "./BaseSingle.vue?vue&type=template&id=118d1c42&"
import script from "./BaseSingle.vue?vue&type=script&lang=js&"
export * from "./BaseSingle.vue?vue&type=script&lang=js&"
import style0 from "./BaseSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseSingle.vue"
export default component.exports